// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1gzlY","title":"Info_title__88Phj","links":"Info_links__1jkTg","link":"Info_link__3iLxT","logo":"Info_logo__11bII"};